"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetch_1 = require("../utils/fetch");
var transform_1 = require("../utils/transform");
exports.default = {
    getAllCandidates: function (params) {
        return fetch_1.default("/candidates", {
            method: "GET",
        }, params);
    },
    getSavedCandidates: function (params) {
        return fetch_1.default("/saved-candidates", {
            method: "GET",
        }, params);
    },
    saveCandidate: function (data) {
        var url = "/save-candidate";
        var body = JSON.stringify(transform_1.toSnakeCase(data));
        return fetch_1.default(url, {
            method: "POST",
            body: body,
        });
    },
    removeCandidate: function (data) {
        var url = "/remove-candidate";
        var body = JSON.stringify(transform_1.toSnakeCase(data));
        return fetch_1.default(url, {
            method: "POST",
            body: body,
        });
    },
};
//# sourceMappingURL=candidates.js.map